import { render } from "./InlineNotification.vue?vue&type=template&id=f8ce9464"
import script from "./InlineNotification.vue?vue&type=script&lang=js"
export * from "./InlineNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__